import { activityCategories } from "@/mocks/events";

const categoryImages = [
  "https://public.readdy.ai/ai/img_res/6b5420464936db8e1ecdbffd116ff532.jpg",
  "https://readdy.ai/api/search-image?query=intellectual%20book%20club%20gathering%20in%20cozy%20cafe%2C%20people%20engaged%20in%20deep%20discussion%2C%20warm%20lighting%2C%20books%20and%20tea%20on%20table%2C%20Taiwan%20lifestyle&width=600&height=400&seq=cat002&orientation=landscape",
  "https://readdy.ai/api/search-image?query=fun%20social%20mixer%20event%20with%20young%20adults%2C%20team%20games%20and%20laughter%2C%20colorful%20indoor%20venue%2C%20Taiwan%20social%20gathering%2C%20energetic%20atmosphere&width=600&height=400&seq=cat003&orientation=landscape",
  "https://readdy.ai/api/search-image?query=family%20outdoor%20activities%20with%20children%20in%20nature%2C%20parents%20and%20kids%20exploring%20forest%2C%20happy%20moments%2C%20Taiwan%20family%20event%2C%20warm%20sunlight&width=600&height=400&seq=cat004&orientation=landscape",
];

export default function ActivityCategories() {
  return (
    <section id="activity-categories" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-14">
          <p className="text-red-600 text-sm font-semibold tracking-widest uppercase mb-3">
            Activity Categories
          </p>
          <h2
            className="text-3xl md:text-5xl font-black text-gray-900"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            四種方式
            <br />
            定義你的紅歡密
          </h2>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {activityCategories.map((cat, idx) => (
            <div
              key={cat.id}
              className={`rounded-2xl overflow-hidden cursor-pointer group border ${cat.borderColor} bg-white hover:shadow-lg transition-all duration-300`}
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={categoryImages[idx]}
                  alt={cat.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                {/* Icon */}
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${cat.color} mb-4`}>
                  <i className={`${cat.icon} text-2xl ${cat.accentColor}`} />
                </div>

                <h3 className="text-gray-900 font-bold text-xl mb-2">{cat.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{cat.description}</p>

                <div className="flex items-center justify-between">
                  <span className={`text-xs font-medium ${cat.accentColor}`}>
                    {cat.count} 場活動
                  </span>
                  <button className={`flex items-center gap-1 text-sm font-semibold ${cat.accentColor} cursor-pointer group/btn whitespace-nowrap`}>
                    探索更多
                    <i className="ri-arrow-right-line transition-transform duration-200 group-hover/btn:translate-x-1" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 rounded-2xl overflow-hidden relative" style={{ height: "220px" }}>
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20group%20of%20happy%20people%20at%20outdoor%20event%2C%20celebrating%20together%2C%20Taiwan%20lifestyle%2C%20warm%20sunset%20light%2C%20joyful%20community%20gathering%2C%20wide%20angle%20shot&width=1400&height=400&seq=cat_banner&orientation=landscape"
            alt="活動精彩瞬間"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent flex items-center px-10">
            <div>
              <p className="text-white/80 text-sm mb-2">企業包場 / 客製活動</p>
              <h3
                className="text-white font-black text-2xl md:text-3xl mb-4"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                想要一場不一樣的 Team Building？
              </h3>
              <button className="px-6 py-2.5 rounded-full bg-red-600 text-white font-semibold text-sm hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap">
                企業諮詢專線
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
